import { render, staticRenderFns } from "./dangerShelvesGoods.vue?vue&type=template&id=cdceee0e&scoped=true&"
import script from "./dangerShelvesGoods.vue?vue&type=script&lang=js&"
export * from "./dangerShelvesGoods.vue?vue&type=script&lang=js&"
import style0 from "./dangerShelvesGoods.vue?vue&type=style&index=0&id=cdceee0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdceee0e",
  null
  
)

export default component.exports